import apiService from '../services/shared/agentPortalApiService.js';

export const getContacts = async (context, config) => {
  var rs = await apiService.getContacts(config.clientId, config.skipCount);
  if (rs.code !== 0 && rs.code !== 2) {
    context.commit('setError', 'Unable to fetch client contacts. Please try again later.');
    return;
  }

  if ((rs.data || null) === null || (rs.data[0] || null) === null) {
    context.commit('setContacts', {
      contacts: [],
      totalCount: 0,
      overwriteContacts: config.overwriteContacts
    });
  } else {
    var data = rs.data[0];
    data.overwriteContacts = config.overwriteContacts;
    context.commit('setContacts', data);
  }
};

export const getProfileDetails = async (context, rqConfig) => {
  var rs = await apiService.getProfileDetails(rqConfig.clientId, rqConfig.profileId);
  if (rs.code !== 0 && rs.code !== 2) {
    context.commit('setError', 'Unable to fetch personal profile. Please try again later.');
    return null;
  }

  return rs.data[0];
};

export const setError = (context, error) => {
  context.commit('setError', error);
};

export const setPolicyTitle = (context, title) => {
  context.commit('setPolicyTitle', title);
};

export const setLobName = (context, name) => {
  context.commit('setLobName', name);
};

export const setClient = (context, client) => {
  context.commit('setClient', client);
};

export const clearClient = (context) => {
  context.commit('setClient', null);
  context.commit('setContacts', {
    contacts: [],
    totalCount: 0,
    overwriteContacts: true
  });
};

export const clearError = (context) => {
  context.commit('clearError');
};

export const toggleTabView = (context) => {
  context.commit('toggleTabView');
};

export const setActiveClientTab = (context, val) => {
  context.commit('setActiveClientTab', val);
};

export const setActivePolicyTab = (context, val) => {
  context.commit('setActivePolicyTab', val);
};

export const setActiveLineOfBusinessTab = (context, val) => {
  context.commit('setActiveLineOfBusinessTab', val);
};

export const setActiveVehicleTab = (context, val) => {
  context.commit('setActiveVehicleTab', val);
};

export const setSelectedProfile = (context, id) => {
  context.commit('setSelectedProfile', id);
};

export const setSelectedLineOfBusinessCode = (context, code) => {
  context.commit('setSelectedLineOfBusinessCode', code);
};

export const resetClientState = (context) => {
  context.commit('setClient', null);
  context.commit('setContacts', {
    contacts: [],
    totalCount: 0,
    overwriteContacts: true
  });
  context.commit('setPolicyTitle', null);
  context.commit('setLobName', null);
};
